export const SET_ORGANIZER_ARTICLES = 'SET_ORGANIZER_ARTICLES';
export const FOLLOW_ORGANIZER = 'FOLLOW_ORGANIZER';
